module.exports = __webpack_public_path__ + "static/media/Untitled_Artwork.513ddd42.png";